import Report from '@frontend/report'

const caReport = new Report()
caReport.init({
  product_code: 'eduzone',
  url: 'https://collection.codemao.cn/report/eduzone',
  is_dev: CONFIG.iris !== 'prod',
  debug: false
})

window.caReport = caReport

export default caReport

export function addEvent(key, params = {}) {
  caReport.add_event({
    key,
    segmentation: params
  })
}
